import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CreateImportantAlertPopupComponent, CreateImportantAlertInput, CreateImportantAlertResult } from './create-important-alert-popup.component';
import { ModalDialogService } from '../../modal-dialog/modal-dialog.service';

@NgModule({
  declarations: [CreateImportantAlertPopupComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule
  ],
  providers: [
    ModalDialogService<CreateImportantAlertResult, CreateImportantAlertInput>
  ],
  exports: [CreateImportantAlertPopupComponent]
})
export class CreateImportantAlertPopupModule {}
